/*
 *
 *  算量报价-物料单项组件
 *
 */
import { Divider, InputNumber, Select, Space, Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import SvgIcon from '&/components/SvgIcon';
import './index.scss';
import { useEffect } from 'react';

const { Option } = Select;

export default function ItemComponent(props) {
    const { item, onClick, showImg = true } = props;
    const [editQuantity, setEditQuantity] = useState(false);
    const [editPrice, setEditPrice] = useState(false);
    const [quantity, setQuantity] = useState(item.quantity.toFixed(0));
    const [unitPrice, setUnitPrice] = useState(item.unit_price.toFixed(2));
    const [newUnitPrice, setNewUnitPrice] = useState('');
    const oldQuantity = item.quantity.toFixed(0);
    const oldUnitPrice = item.unit_price.toFixed(2);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    console.log('oldQuantity', oldQuantity);

    console.log('oldUnitPrice', oldUnitPrice);

    useEffect(() => {
        // 初始化时设置数量和单价
        setQuantity(item.quantity.toFixed(0));
        setUnitPrice(item.unit_price.toFixed(2));
        // setNewUnitPrice(item.unit_price.toFixed(2));
    }, [item]);

    const handleClick = () => {
        if (onClick) {
            onClick(item);
        }
    };

    const onQuantityChange = value => {
        setQuantity(value);
    };

    const list = [
        { value: '0.00' },
        { value: '0.01' },
        { value: '0.02' },
        { value: '0.03' },
    ];

    const onBlurSelect = _newUnitPrice => {
        console.log('newUnitPrice', newUnitPrice);
        if (!!newUnitPrice || !!_newUnitPrice) {
            onChangeSelect(_newUnitPrice || newUnitPrice);
            // 在onBlur后将对应的newValue置成初始状态
            // 防止当从下拉框中选择后再次触发onBlur时经过此处恢复成原来的值
            setNewUnitPrice('');
        }
    };

    const onChangeSelect = value => {
        console.log('value', value);
        let record = value || '';
        setUnitPrice(record);
    };

    const onSearchSelect = value => {
        if (!!value) {
            let newValue = value || '';
            setNewUnitPrice(newValue);
        }
    };

    const onConfirmSelect = () => {
        if (!!unitPrice || unitPrice === 0) {
            setEditPrice(false);
            let obj = {
                id: item.id,
                type: 1,
                value: parseFloat(unitPrice),
            };
            console.log('onConfirmSelect obj', obj);
            console.log('API Name: ModifyItem');
            try {
                window.external.DispatchFun(
                    'Quantity',
                    'ModifyItem',
                    JSON.stringify(obj)
                );
            } catch (error) {
                console.error('DispatchFun error:', error);
            }
        }
    };

    const onConfirmInputNumber = () => {
        if (!!quantity) {
            setQuantity(quantity);
            setEditQuantity(false);
            let obj = {
                id: item.id,
                type: 2,
                value: parseFloat(quantity),
            };
            console.log('onConfirmInputNumber obj', obj);
            console.log('API Name: ModifyItem');
            try {
                window.external.DispatchFun(
                    'Quantity',
                    'ModifyItem',
                    JSON.stringify(obj)
                );
            } catch (error) {
                console.error('DispatchFun error:', error);
            }
        }
    };

    const onDeleteOk = () => {
        // Simulate a delete operation
        setDeleteOpen(false);
        // Here you would typically call a delete API
        console.log(`Deleted item with ID: ${item.id}`);
        setLoading(false);
        let obj = {
            id: item.id,
        };
        window.external.DispatchFun(
            'Quantity',
            'DeleteItem',
            JSON.stringify(obj)
        );
    };

    const onFocus = item => {
        console.log('item', item);
    };

    return (
        <div className={`item-component id-${item.id}`} onClick={handleClick}>
            {showImg && (
                <div className="item-img">
                    <img src={item.image || item.thumbnail} alt={item.name} />
                </div>
            )}
            <div className="item-info">
                <div className="item-name" title={item.name}>
                    {item.name}
                </div>
                <div
                    className="item-description overflow-hidden"
                    title={
                        '规格：' +
                        item.description +
                        ' | 品牌：' +
                        (item.brand ? item.brand : '-')
                    }>
                    规格：{item.description} <Divider type="vertical" /> 品牌：
                    {item.brand ? item.brand : '-'}
                </div>
            </div>
            <div className="item-number">
                {editQuantity ? (
                    <Space size={4}>
                        <InputNumber
                            onChange={onQuantityChange}
                            value={quantity}
                            className="form-item"
                        />
                        <SvgIcon
                            iconName="icon-confirm"
                            onClick={() => onConfirmInputNumber(false)}
                        />
                        <SvgIcon
                            iconName="icon-del"
                            onClick={() => {
                                setEditQuantity(false);
                                setQuantity(oldQuantity);
                            }}
                        />
                    </Space>
                ) : (
                    <div className="item-quantity item-content">
                        <div className="overflow-wrap">{quantity}个</div>
                        <SvgIcon
                            iconName="Icon-Pencil"
                            className="edit-btn"
                            onClick={() => setEditQuantity(true)}
                        />
                    </div>
                )}
                <div className="item-unit">数量</div>
            </div>
            <div className="item-price">
                {editPrice ? (
                    <Space size={4}>
                        <Select
                            allowClear
                            showSearch
                            className="form-item form-item-select"
                            placeholder="请下拉选择"
                            onChange={onChangeSelect}
                            onSearch={onSearchSelect}
                            onBlur={() => onBlurSelect()}
                            onFocus={() => onFocus(item)}
                            optionFilterProp="children"
                            value={unitPrice}
                            getPopupContainer={() =>
                                document.querySelector('.form-item-select')
                            }>
                            {list.map((item, index) => (
                                <Option key={index} value={item.value}>
                                    {item.value}
                                </Option>
                            ))}
                        </Select>
                        <SvgIcon
                            iconName="icon-confirm"
                            onClick={() => onConfirmSelect(false)}
                        />
                        <SvgIcon
                            iconName="icon-del"
                            onClick={() => {
                                setEditPrice(false);
                                onBlurSelect(oldUnitPrice);
                                // setNewUnitPrice(oldUnitPrice);
                            }}
                        />
                    </Space>
                ) : (
                    <div className="item-unit-price item-content">
                        <div className="overflow-wrap">¥ {unitPrice} </div>
                        <SvgIcon
                            iconName="Icon-Pencil"
                            className="edit-btn"
                            onClick={() => setEditPrice(true)}
                        />
                    </div>
                )}
                <div className="item-unit">价格</div>
            </div>
            <div className="item-total">
                <div className="item-total-price item-content">
                    <div className="overflow-wrap">
                        ¥ {item.price.toFixed(2)}
                    </div>
                </div>
                <div className="item-unit">小计</div>
            </div>
            <div className="item-action">
                <button
                    className="action-btn edit-btn"
                    onClick={() => setDeleteOpen(true)}>
                    <SvgIcon iconName="Icon-Trash" />
                </button>
            </div>

            <Modal
                title="提示"
                visible={deleteOpen}
                onOk={onDeleteOk}
                onCancel={() => setDeleteOpen(false)}
                okText="确认"
                cancelText="取消"
                width={369}
                getContainer={() =>
                    document.querySelector('.hdd-quantity-toke-off')
                }
                footer={[
                    <Button
                        key="submit"
                        className="confirm-btn"
                        loading={loading}
                        onClick={onDeleteOk}>
                        确定
                    </Button>,
                    <Button key="back" onClick={() => setDeleteOpen(false)}>
                        取消
                    </Button>,
                ]}>
                <p>
                    <ExclamationCircleOutlined
                        style={{
                            color: '#FFD225',
                            fontSize: '24px',
                            marginRight: '8px',
                        }}
                    />
                    确认删除？？？
                </p>
            </Modal>
        </div>
    );
}
